import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme=>({
  wrapper: {
    display: 'flex',
    overflowY: 'auto',
    padding: '18px 40px 0',
    margin: '-18px 0 0',
    height: 'calc(100% - 125px)',
    ['@media (max-width:1010px)']: {
      padding: '18px 0 0 40px',
      height: 'calc(100% - 125px)'
    },
    ['@media (max-width:850px)']: {
      padding: '0 0 0 40px',
      margin: '0px',
      height: 'calc(100% - 64px)'
    },
    ['@media (max-width:600px)']: {
      padding: '0 0 0 15px',
      height: 'calc(100% - 102px)'
    }
  },
  leftSide: {
    width: '100%',
    padding: '0 40px 0 1px',
    ['@media (max-width:1010px)']: {
      paddingRight: '40px'
    },
    ['@media (max-width:850px)']: {
      marginTop: 0
    },
    ['@media (max-width:600px)']: {
      paddingRight: '15px',
      marginTop: 0
    }
  },
  rightSide: {
    width: '300px',
    minWidth: '300px',
    ['@media (max-width:1010px)']: {
      display: 'none'
    }
  },
  sectionTitleIndent: {
    marginBottom: '20px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  addOnWrapperClass: {
    marginBottom: '10px'
  },
  addOnItemClass: {
    '&:last-child': {
      borderBottom: 0
    }
  },
  addOnTitleClass: {
    fontSize: '14px'
  },
  addOnDescClass: {
    width: 'calc(100% - 163px)',
    ['@media (max-width:600px)']: {
      width: 'calc(100% - 83px)',
      textAlign: 'left'
    },
  },
  form: {
    height: 'inherit'
  }
}));

export default useStyles;
